import { render, staticRenderFns } from "./ModalContentExpenseDelete.vue?vue&type=template&id=c2445e7e&scoped=true&"
import script from "./ModalContentExpenseDelete.vue?vue&type=script&lang=js&"
export * from "./ModalContentExpenseDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentExpenseDelete.vue?vue&type=style&index=0&id=c2445e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2445e7e",
  null
  
)

export default component.exports